import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-info-modal',
  imports: [],
  templateUrl: './info-modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InfoModalComponent {
  readonly title = signal('');
  readonly message = signal('');
  readonly icon = signal('');
  readonly alertClasses = signal('alert-success border-success');

  private readonly activeModal = inject(NgbActiveModal);

  close(): void {
    this.activeModal.close();
  }
}
